import api from '@/api'
import storage from 'libs/storage'

export default {
    state: {
        appInfo: '',
        showSpin: false,
        custombgcolor:""
    },
    getters: {
        getAppInfo: state => {
            var appinfo = {}
            if (state.appInfo) {
                appinfo = state.appInfo
            } else {
                appinfo = storage.get('appInfo');
            }
            return appinfo;
        }
    },
    mutations: {
        setBgColor(state,color){
          state.custombgcolor   =   color
        },
        setAppInfo(state, appInfo) {
            state.appInfo = appInfo
        },
        handleSpinShow(state, value) {
            if (!value) {
                setTimeout(() => {
                    state.showSpin = value
                }, 500)
            } else {
                state.showSpin = value

            }

        }
    },
    actions: {
        handleAppInfo({ commit }, info) {
            var appinfo =storage.set('appInfo', info);
            commit('setAppInfo', appinfo);
        },
        getLaunchInfo({ commit }) {

            return new Promise((resolve, reject) => {
                try {
                    api.system.appLaunch().then((res) => {
                        if (res.status * 1 === 200) {
                            commit('setAppInfo', res.data);
                            storage.set('appInfo', res.data, true);
                        }
                        resolve(res);
                    })
                } catch (error) {
                    reject(error);
                }
            });


        }
    }
}
